<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Detalle Grupo Bebeficios</mat-card-title>
        </mat-card-header-->
        <mat-card-content>

            <form class="form-container" (ngSubmit)="onSubmitFormulaGroup(formulaGroupForm)" #formulaGroupForm="ngForm" >

                <mat-card class="general-wf-card" appearance="outlined">
                    <mat-card-header>
                        <mat-card-title>Datos Generales</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div id="container" class="formControl">
                                
                        <div class="control">
                            <mat-form-field class="imput-full-width">
                            <mat-label>Descripción de Grupo</mat-label>
                            <input type="text" matInput name="formulaGroup.description" [(ngModel)]="formulaGroup.description" >
                            </mat-form-field>
                        </div>

                        <div class="control"> 
                            <button mat-flat-button class="button buttonWidth" type="button" (click)="addFormulaConf()">
                            Agregar Formula
                            </button>
                        </div>

                        </div>
                    </mat-card-content>
                </mat-card>
                <br>

                <div *ngFor="let formulaConfiguration of formulaGroup.formulaConfigurations; let listIndex = index">
                    <mat-card class="general-wf-card" appearance="outlined">
                        <mat-card-header>
                            <h4>Configuraciones de Formula</h4>
                        </mat-card-header>
                        <mat-card-content>
                            <div id="container" class="formControl">
                                
                                <div class="control">
                                    <mat-form-field class="controlWidth">
                                      <mat-label>Objecto</mat-label>
                                      <mat-select [(ngModel)]="formulaConfiguration.object"  [compareWith]="compareObject" name="formulaConfiguration.object.description{{listIndex}}">
                                        @for (object of objects ; track object.id) {
                                          <mat-option [value]="object">{{ object.description }}</mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                </div>
                                
                                <div class="control">
                                    <mat-form-field class="controlWidth">
                                      <mat-label>Variable</mat-label>
                                      <mat-select [(ngModel)]="formulaConfiguration.variable"  [compareWith]="compareVariable" name="formulaConfiguration.variable.description{{listIndex}}">
                                        @for (variable of variables ; track variable.id) {
                                          <mat-option [value]="variable">{{ variable.description }}</mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="control">
                                    <mat-form-field class="imput-full-width">
                                    <mat-label>Descripción de Formula</mat-label>
                                    <input type="text" matInput name="formulaConfiguration.description{{listIndex}}" [(ngModel)]="formulaConfiguration.description" >
                                    </mat-form-field>
                                </div>
    
                            </div>

                            <div id="container" class="formControlTA">
                                <div class="control">
                                    <mat-form-field class="controlWidthTextArea">
                                        <mat-label>Formula</mat-label>
                                        <textarea matInput placeholder="Formula" name="formulaConfiguration.formula{{listIndex}}" [(ngModel)]="formulaConfiguration.formula"></textarea>
                                        <mat-error>{{ violations['formulaConfiguration.formula{{listIndex}}'] }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <!---table class="table-div-area">
                                <thead>
                                    <tr>
                                    <th>División / Área</th>
                                    <th *ngFor="let area of areas">{{ area.description }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let division of divisions; let rowIndex = index" [class.hovered-row]="hoveredRow === rowIndex">
                                    <td>{{ division.description }}</td>
                                    <td *ngFor="let area of areas; let colIndex = index"
                                        [class.hovered-col]="hoveredCol === colIndex"
                                        (mouseenter)="onMouseEnter(rowIndex, colIndex)"
                                        (mouseleave)="onMouseLeave()">
                                        <input type="checkbox"
                                        [checked]="isSelected(listIndex, division.id, area.id)"
                                        (change)="onCheckboxChange(listIndex, division, area, $event)"
                                        />
                                    </td>
                                    </tr>
                                </tbody>
                            </table-->
                        </mat-card-content>
                    </mat-card>
                    <br>
                </div>
                
                <div class="formControl">
                    <div class="control">
                    <button mat-flat-button class="button buttonWidth">
                        {{(formulaGroup.id > 0)? 'Actualizar': 'Guardar'}}
                    </button>
                    </div>
                </div>
                
            </form>

    </mat-card-content>
</mat-card>